import { render, staticRenderFns } from "./forgetPasswordNew.vue?vue&type=template&id=dde6fa9c&scoped=true&"
import script from "./forgetPasswordNew.vue?vue&type=script&lang=js&"
export * from "./forgetPasswordNew.vue?vue&type=script&lang=js&"
import style0 from "./forgetPasswordNew.vue?vue&type=style&index=0&id=dde6fa9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dde6fa9c",
  null
  
)

export default component.exports